import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7420ba11")

_pushScopeId("data-v-7420ba11")
const _hoisted_1 = { class: "call-mode-form" }
const _hoisted_2 = { class: "call-mode" }
const _hoisted_3 = {
  class: "d-flex align-items-center",
  style: {"justify-content":"space-between"}
}
const _hoisted_4 = { class: "p-field-label" }
const _hoisted_5 = { class: "p-field mt-3" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mt-4 call-mode" }
const _hoisted_9 = {
  key: 0,
  class: "p-field"
}
const _hoisted_10 = { class: "p-field-label" }
const _hoisted_11 = {
  key: 1,
  class: "p-field wizard-style-brfa"
}
const _hoisted_12 = { class: "p-field mb-2" }
const _hoisted_13 = { class: "p-field-label" }
const _hoisted_14 = { class: "menu-filters" }
const _hoisted_15 = /*#__PURE__*/_createVNode("hr", { class: "hr" }, null, -1)
const _hoisted_16 = { class: "p-field mb-2" }
const _hoisted_17 = { class: "p-field-label" }
const _hoisted_18 = { class: "menu-filters" }
const _hoisted_19 = /*#__PURE__*/_createVNode("hr", { class: "hr" }, null, -1)
const _hoisted_20 = { class: "p-field mb-2" }
const _hoisted_21 = { class: "p-field-label" }
const _hoisted_22 = { class: "menu-filters" }
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", { class: "hr" }, null, -1)
const _hoisted_24 = { class: "p-field mb-2" }
const _hoisted_25 = { class: "p-field-label" }
const _hoisted_26 = { class: "menu-filters" }
const _hoisted_27 = /*#__PURE__*/_createVNode("hr", { class: "hr" }, null, -1)
const _hoisted_28 = {
  key: 2,
  class: "p-field"
}
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "mt-1 text-gray" }
const _hoisted_31 = { class: "p-field-label mt-4 mb-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HelpPopupButton = _resolveComponent("HelpPopupButton")
  const _component_ListItemRadio = _resolveComponent("ListItemRadio")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_ToggleSwitchButton = _resolveComponent("ToggleSwitchButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.CallMode")), 1),
        _createVNode(_component_HelpPopupButton, {
          helpType: _ctx.HelpType.CallModeTypes
        }, null, 8, ["helpType"])
      ]),
      _createVNode("div", _hoisted_5, [
        (!_ctx.adminView)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_ListItemRadio, {
                disabled: _ctx.disabled,
                modelValue: _ctx.callMode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.callMode = $event)),
                label: _ctx.$t('AppResourceEP.AddressBook'),
                sublabel: _ctx.$t('AppResourceEP.AddressBookDescription'),
                inputId: "AddressBook",
                name: "callMode",
                value: 0
              }, null, 8, ["disabled", "modelValue", "label", "sublabel"]),
              _createVNode(_component_ListItemRadio, {
                disabled: _ctx.disabled,
                modelValue: _ctx.callMode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.callMode = $event)),
                label: _ctx.$t('AppResourceEP.CallWithCode'),
                sublabel: _ctx.$t('AppResourceEP.CallWithCodeDescription'),
                inputId: "DirectCall",
                name: "callMode",
                value: 1
              }, null, 8, ["disabled", "modelValue", "label", "sublabel"]),
              _createVNode(_component_ListItemRadio, {
                disabled: _ctx.disabled,
                modelValue: _ctx.callMode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.callMode = $event)),
                label: _ctx.$t('AppResourceEP.BuildingRiserFloorApartment'),
                sublabel: _ctx.$t('AppResourceEP.BrfaDescription'),
                inputId: "BuildingRiserFloorApartment",
                name: "callMode",
                value: 2,
                last: ""
              }, null, 8, ["disabled", "modelValue", "label", "sublabel"])
            ]))
          : (_ctx.adminView)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_ListItemRadio, {
                  modelValue: _ctx.callMode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.callMode = $event)),
                  label: _ctx.adminViewChosedOptionLabel,
                  sublabel: _ctx.adminViewChosedOptionDescription,
                  inputId: '',
                  name: "callMode",
                  value: _ctx.callMode,
                  disabled: "",
                  last: ""
                }, null, 8, ["modelValue", "label", "sublabel", "value"])
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      (_ctx.callMode === _ctx.CallMode.Address)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.Sorting")), 1),
            _createVNode(_component_Dropdown, {
              disabled: !_ctx.sortingEnabled || _ctx.adminView,
              class: "sorting__dropdown",
              modelValue: _ctx.infoPlant.addressBookSorting,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.infoPlant.addressBookSorting = $event)),
              options: _ctx.addressBookSortingOptions,
              optionLabel: "name",
              optionValue: "code"
            }, null, 8, ["disabled", "modelValue", "options"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.callMode === _ctx.CallMode.Brfa)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("label", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.SetupBrfaTitle")) + " ", 1),
                _createVNode("strong", null, _toDisplayString(_ctx.$t("AppResourceEP.Buildings")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_SelectButton, {
                disabled: _ctx.disabled || _ctx.adminView,
                modelValue: _ctx.infoPlant.denominationBuildings,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.infoPlant.denominationBuildings = $event)),
                options: _ctx.settingsList,
                dataKey: "value",
                optionLabel: "label",
                optionValue: "value",
                class: { 'p-disabled': _ctx.disabled || _ctx.adminView }
              }, null, 8, ["disabled", "modelValue", "options", "class"])
            ]),
            _hoisted_15,
            _createVNode("div", _hoisted_16, [
              _createVNode("label", _hoisted_17, [
                _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.SetupBrfaTitle")) + " ", 1),
                _createVNode("strong", null, _toDisplayString(_ctx.$t("AppResourceEP.Risers")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_SelectButton, {
                disabled: _ctx.disabled || _ctx.adminView,
                modelValue: _ctx.infoPlant.denominationRisers,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.infoPlant.denominationRisers = $event)),
                options: _ctx.settingsList,
                dataKey: "value",
                optionLabel: "label",
                optionValue: "value",
                class: { 'p-disabled': _ctx.disabled || _ctx.adminView }
              }, null, 8, ["disabled", "modelValue", "options", "class"])
            ]),
            _hoisted_19,
            _createVNode("div", _hoisted_20, [
              _createVNode("label", _hoisted_21, [
                _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.SetupBrfaTitle")) + " ", 1),
                _createVNode("strong", null, _toDisplayString(_ctx.$t("AppResourceEP.Floors")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode(_component_SelectButton, {
                disabled: _ctx.disabled || _ctx.adminView,
                modelValue: _ctx.infoPlant.denominationFloors,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.infoPlant.denominationFloors = $event)),
                options: _ctx.settingsList,
                dataKey: "value",
                optionLabel: "label",
                optionValue: "value",
                class: { 'p-disabled': _ctx.disabled || _ctx.adminView }
              }, null, 8, ["disabled", "modelValue", "options", "class"])
            ]),
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              _createVNode("label", _hoisted_25, [
                _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.SetupBrfaTitle")) + " ", 1),
                _createVNode("strong", null, _toDisplayString(_ctx.$t("AppResourceEP.Apartments")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_SelectButton, {
                disabled: _ctx.disabled || _ctx.adminView,
                modelValue: _ctx.infoPlant.denominationApartments,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.infoPlant.denominationApartments = $event)),
                options: _ctx.settingsList,
                dataKey: "value",
                optionLabel: "label",
                optionValue: "value",
                class: { 'p-disabled': _ctx.disabled || _ctx.adminView }
              }, null, 8, ["disabled", "modelValue", "options", "class"])
            ]),
            _hoisted_27
          ]))
        : _createCommentVNode("", true),
      (_ctx.callMode === _ctx.CallMode.DirectCall)
        ? (_openBlock(), _createBlock("div", _hoisted_28, [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_29, [
                _createVNode("div", null, [
                  _createVNode("label", null, _toDisplayString(_ctx.$t("AppResourceEP.ShowTheAddressBook")), 1),
                  _createVNode("div", _hoisted_30, [
                    _createVNode("small", null, _toDisplayString(_ctx.$t(
                                            "AppResourceEP.ShowTheAddressBookDescription"
                                        )), 1)
                  ])
                ]),
                _createVNode(_component_ToggleSwitchButton, {
                  disabled: !_ctx.sortingEnabled || _ctx.adminView,
                  class: "ml-auto",
                  modelValue: _ctx.infoPlant.callingCodeShowAddressBook,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.infoPlant.callingCodeShowAddressBook = $event))
                }, null, 8, ["disabled", "modelValue"])
              ])
            ]),
            _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("AppResourceEP.Code")), 1),
            _createVNode("div", null, [
              _createVNode(_component_ListItemRadio, {
                disabled: !_ctx.sortingEnabled || _ctx.adminView,
                modelValue: _ctx.infoPlant.addressingType,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.infoPlant.addressingType = $event)),
                label: _ctx.$t('AppResourceEP.Numeric'),
                inputId: "Numeric",
                name: "Code",
                value: 3
              }, null, 8, ["disabled", "modelValue", "label"]),
              _createVNode(_component_ListItemRadio, {
                disabled: !_ctx.sortingEnabled || _ctx.adminView,
                modelValue: _ctx.infoPlant.addressingType,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.infoPlant.addressingType = $event)),
                label: _ctx.$t('AppResourceEP.Alphanumeric'),
                inputId: "Alphanumeric",
                name: "Code",
                value: 2,
                last: ""
              }, null, 8, ["disabled", "modelValue", "label"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})